import { ComponentStyleConfig } from '@chakra-ui/react'

export const Modal: ComponentStyleConfig = {
  baseStyle: {
    body: {
      p: 6,
    },
    closeButton: {
      color: 'deepPurple',
      insetEnd: 5,
      top: 4,
    },
    dialog: {
      mx: 4,
    },
    dialogContainer: {
      // For Safari on iPhone, see https://maxschmitt.me/posts/css-100vh-mobile-browsers/
      bottom: 0,
      height: 'auto',
    },
    footer: {
      p: 6,
    },
    header: {
      p: 6,
      textStyle: 'headers.2xl',
    },
    overlay: {
      backdropFilter: 'blur(1px)',
    },
  },
}
